import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { FaArrowDown } from "react-icons/fa";
import TeamData from './Team.json';
import Divider from '@mui/material/Divider';

export default function Team() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className=''>
      <h2 className='text-lg font-bold pb-4 pt-8'>Our Team</h2>
      
      {TeamData.map((member) => (
        <Accordion 
        style={{ backgroundColor: "rgba(248, 247, 255, 0.5)" }}
          key={member.ID}
          expanded={expanded === `panel${member.ID}`}
          onChange={handleChange(`panel${member.ID}`)}
          className='mb-2 shadow-sm'
        >
          <AccordionSummary
            expandIcon={<FaArrowDown className="text-[#F61832]" />}
            aria-controls={`panel${member.ID}-content`}
            id={`panel${member.ID}-header`}
          >
            <div className="flex flex-col">
              <div className="font-bold">
                {member.Name}
              </div>
              <div component="span" className="">
                {member.Position}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className="bg-[#F8F7FF] p-4">
            <div className='mb-4'><Divider/></div>
            <div className="">
              {member.Bio}
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}